<ng-container
  *ngIf="{ isLoggedIn: isLoggedIn$ | async, shouldDisplayUserFirstname: shouldDisplayUserFirstname$ | async } as observables"
>
  <ul ngbNav #nav="ngbNav" class="nav-tabs mobile-menu">
    <li [ngbNavItem]="0" role="presentation">
      <a ngbNavLink>{{ 'navigation.menu_tab_mobile' | cxTranslate }}</a>
      <ng-template ngbNavContent>
        <ul *ngFor="let navigationLink of navigationNode?.children">
          <ng-container *ngFor="let childLink of navigationLink.children">
            <ng-container [ngSwitch]="childLink.uid">
              <li py-megamenu-list-item *ngSwitchCase="'header_products_link'">
                <ng-container [ngTemplateOutlet]="childLinkButton" [ngTemplateOutletContext]="{ childLink: childLink }">
                </ng-container>
              </li>

              <li py-megamenu-list-item *ngSwitchCase="'header_services_link'">
                <cx-generic-link *ngIf="childLink.styleClasses?.includes(directServicesLinkStyleClass)" [url]="childLink.url">
                  {{ childLink.title }}
                </cx-generic-link>
                <ng-container
                  *ngIf="!childLink.styleClasses?.includes(directServicesLinkStyleClass)"
                  [ngTemplateOutlet]="childLinkButton"
                  [ngTemplateOutletContext]="{ childLink: childLink }"
                >
                </ng-container>
              </li>

              <ng-container *ngSwitchCase="'header_area_of_use_link'">
                <li py-megamenu-list-item *pyPrincipalConfiguration="'enableDisplayAreaOfUse'">
                  <ng-container [ngTemplateOutlet]="childLinkButton" [ngTemplateOutletContext]="{ childLink: childLink }">
                  </ng-container>
                </li>
              </ng-container>

              <li *ngSwitchCase="'header_language_dummy_link'">
                <ng-container [ngTemplateOutlet]="languageLinkButton"> </ng-container>
              </li>

              <li py-megamenu-list-item *ngSwitchDefault="">
                <cx-generic-link [url]="childLink.url">
                  {{ childLink.title }}
                </cx-generic-link>
              </li>
            </ng-container>
          </ng-container>
        </ul>
      </ng-template>
    </li>
    <li [ngbNavItem]="1" [class.disabled]="observables.isLoggedIn" role="presentation">
      <a ngbNavLink><i nz-icon nzType="login" nzTheme="outline"></i> {{ 'navigation.signIn_tab_mobile' | cxTranslate }}</a>
      <ng-template ngbNavContent>
        <py-login></py-login>
      </ng-template>
    </li>
    <li [ngbNavItem]="2" [class.disabled]="!observables.isLoggedIn" role="presentation">
      <a ngbNavLink>
        <ng-container *ngIf="notificationCount$ | async as notificationCount">
          <py-badge *ngIf="notificationCount > 0" id="header-menu-account-badge" [static]="true" [isNotification]="true">
            {{ notificationCount }}
          </py-badge>
        </ng-container>
        <i nz-icon nzType="user" nzTheme="outline"></i>
        <span *ngIf="observables.shouldDisplayUserFirstname" class="username-navigation-link-text">{{
          userFirstName$ | async
        }}</span>
        <ng-container *ngIf="!observables.shouldDisplayUserFirstname">{{
          'navigation.myPage_tab_mobile' | cxTranslate
        }}</ng-container>
      </a>
      <ng-template ngbNavContent>
        <ng-container [cxComponentWrapper]="{ uid: 'my_page_current_customer', flexType: 'CmsMyPageCurrentCustomerComponent' }">
        </ng-container>
        <ng-container [cxComponentWrapper]="{ uid: 'my_page_menu_flexnav', flexType: 'CmsMyPageMenuComponent' }"> </ng-container>
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="nav" class="mt-6 mx-4"></div>
</ng-container>

<ng-template #childLinkButton let-childLink="childLink">
  <a (click)="handleMenuListItemClick(childLink)">
    {{ childLink.title }}
  </a>
</ng-template>

<ng-template #languageLinkButton>
  <py-menu-site-context class="w-100" [mode]="menuSiteContextModes.DROPDOWN"></py-menu-site-context>
</ng-template>
